<template>
  <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('taxes.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <Button v-if="$can(abilities.CREATE_TAX)" btn-class="btn-sm" type="new" btn-text="taxes.create" @click="openTaxModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_taxes" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class="min-w-200px">{{ $t('taxes.title')}}</th>
              <th class="min-w-100px">{{ $t('taxes.type')}}</th>
              <th class="min-w-100px">{{ $t('taxes.amount')}}</th>
              <th class="min-w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>

        </div>
      </div>
      <TaxFormModal id="create-tax-form-modal" @load="fetchDatas" />
      <TaxFormModal :is-edit="true" id="edit-tax-form-modal" :tax="formUpdateData" @load="fetchDatas"/>
    </div>
</template>

<script setup>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import i18n from '@/plugins/i18n';
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import TaxFormModal from '@/components/Tax/CreateTax.vue'
import {useStore} from "vuex";
import {$formatLocalAmount} from "@/mixins/Helpers"
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";

const {showSwal} = useSwal()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const currency = computed(() => 'XOF')
const { can } = useHasAbility()

const table = ref()

const formUpdateData = ref({
  id:'',
  title: '',
  type: 'percent',
  amount: 0
})

onMounted(() => {
  fetchDatas()
})

watch(() => locale.value, () => {
  nextTick(() =>   fetchDatas() )
})

function getTypeName(name){
  return name == "amount" ? i18n.global.t('taxes.amount') : i18n.global.t('taxes.percent')
}

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#kt_datatable_taxes").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 1, 'asc']],
    ajax: {
      url: BASE_URL + "/get/taxes/datatables",
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
      }
    },
    columns: [
      { data: "title" },
      { data: "type" },
      { data: "amount" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -4,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t) {
          return '<span >' + t + "</span>";
        },
      },
      {
        targets: -3,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t) {
          return '<span >' + getTypeName(t) + "</span>";
        },
      },
      {
        targets: -2,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span >' + $formatLocalAmount(t) + "</span>";
        },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: function(t, a, e, l) {
          let render=""
          if(can(abilities.UPDATE_TAX)){
            render+='<a data-id="'+ e.id +'" data-title="'+ e.title +'" data-amount="'+ e.amount +'" data-type="'+ e.type +'"  href="javascript:;"   class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-id="'+ e.id +'" data-title="'+ e.title +'" data-amount="'+ e.amount +'" data-type="'+ e.type +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'" ></i></a>'
          }
          if(can(abilities.DELETE_TAX)){
            render += '<a data-id="'+ e.id +'" data-title="'+ e.title +'" data-amount="'+ e.amount +'" data-type="'+ e.type +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" data-title="'+ e.title +'" data-amount="'+ e.amount +'" data-type="'+ e.type +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#kt_datatable_taxes .edit_btn", (e) => {
    formUpdateData.value.id = e.target.getAttribute('data-id')
    formUpdateData.value.title = e.target.getAttribute('data-title')
    formUpdateData.value.type = e.target.getAttribute('data-type')
    formUpdateData.value.amount = e.target.getAttribute('data-amount')
    $('#edit-tax-form-modal').modal('toggle')
  });

  $(document).on("click", "#kt_datatable_taxes .delete_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    deleteTax(id)
  });
}

function openTaxModal() {
  $('#create-tax-form-modal').modal('toggle')
}

async function deleteTax(id) {
  showSwal(
      '',
      i18n.global.t('swal.taxes_deleted')
  ).then( async (result) => {
      if (result.value) {
        try {
          await store.dispatch('taxes/deleteTaxe', id)
          table.value.ajax.reload()
          window.toastr['success'](i18n.global.t("notification.taxe_deleted"))
        }catch (e) {
        }
      }
  })
}
</script>


